export default __webpack_public_path__ + "static/media/HeavensLake.020022d6.jpg";